import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  companyMailId: "",
  firstName: "",
  companyName: "",
  userId: "",
  firstLogin: 0,
  organizationDetails: {}
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state = { ...state, ...action.payload };
      return state;
    },
    removeUser(state) {
      state = { ...state.initialState };
    },
    clearAuth(state, action) {
      return initialState;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
